import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("×")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" We use cookies to ensure you get the best experience on our website. ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://cookiesandyou.com/",
  target: "_blank"
}, "Learn More...", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Opt Out")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Got It!")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark order-2 order-md-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2022©"),
  /*#__PURE__*/_createTextVNode(" TechnoPlanet Productions Inc. All rights reserved ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Law = _resolveComponent("Law")!
  const _component_vue_cookie_accept_decline = _resolveComponent("vue-cookie-accept-decline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Law, { theme: "dark-lime" }),
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createVNode(_component_vue_cookie_accept_decline, {
        debug: false,
        disableDecline: false,
        showPostponeButton: false,
        onClickedAccept: _ctx.cookieClickedAccept,
        onClickedDecline: _ctx.cookieClickedDecline,
        elementId: "myPanel1",
        position: "bottom-left",
        ref: "panelCookie",
        transitionName: "slideFromBottom",
        type: "floating"
      }, {
        postponeContent: _withCtx(() => [
          _hoisted_2
        ]),
        message: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        declineContent: _withCtx(() => [
          _hoisted_5
        ]),
        acceptContent: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClickedAccept", "onClickedDecline"]),
      _hoisted_7
    ], 2)
  ]))
}